import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { httpOptions, serviceConstants } from '../../constants/service.constants';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonSummaryService {

  constructor(private http: HttpClient) { }

  

}

export interface MasterDropDown{
  value?: string;
  label?: string;
  checked?: boolean;
}
